import apiClient from '../utilities/apiClient.utility';

const customerUrl = `${window.config.CONNECT_URLS.customers}`;
const messageUrl = `${window.config.CONNECT_URLS.messages}`;
const storageUrl = `${window.config.CONNECT_URLS.storage}`;

export const carryOverPatientTransaction = async ({ program_id, customer_id }) => {
    return await apiClient.post(
      `${customerUrl}/${program_id}/dashboard/${customer_id}/carry-over`,
      {}
    );
};

export const updateCustomerInfo = async ({ program_id, customer_id, payload }) => { 
  return await apiClient.put(
    `${customerUrl}/${program_id}/dashboard/${customer_id}`, payload
  );
};

export const partialUpdateCustomerInfo = async ({ program_id, customer_id, payload }) => { 
  return await apiClient.patch(
    `${customerUrl}/${program_id}/dashboard/${customer_id}`, payload
  );
};

export const manuallyCreatePatient = async ({ program_id, payload }) => {
  return await apiClient.post(
    `${customerUrl}/${program_id}/dashboard/manual-pre-enrollment`, payload
  );
}

export const sendPatientTnc = async ({ program_id, customer_id }) => {
  return await apiClient.post(
    `${customerUrl}/${program_id}/dashboard/${customer_id}/send-tnc-link`
  );
}

export const standardSchemeAction = async ({ program_id, customer_id, payload, action }) => {
  return await apiClient.post(
    `${customerUrl}/${program_id}/dashboard/${customer_id}/standard-scheme/${action}`,
    payload
  );
}

export const affordabilitySchemeAction = async ({ program_id, customer_id, payload, action }) => {
  return await apiClient.post(
    `${customerUrl}/${program_id}/dashboard/${customer_id}/affordability-scheme/${action}`,
    payload
  );
}

export const getLatestMessage = async ({ program_id, customer_id, query_object }) => { 
  const queryString = toQueryString(query_object);

  return await apiClient.get(
    `${customerUrl}/${program_id}/dashboard/${customer_id}/latest-message${queryString}`
  );
};

export const getLatestPendingCodeMessage = async ({ program_id, customer_id, code_type, code }) => { 
  return await apiClient.get(
    `${customerUrl}/${program_id}/dashboard/${customer_id}/latest-pending-code-message?code_type=${code_type}${code ? `&code=${code}` : ''}`
  );
};

export const validateSelfEnrolledPatient = async ({ program_id, customer_id, payload = {}, action }) => { 
  return await apiClient.post(
    `${customerUrl}/${program_id}/dashboard/${customer_id}/self-enrollment/${action}`,
    payload
  );
};

export const cancelPatient = async ({ program_id, customer_id, payload }) => { 
  return await apiClient.post(
    `${customerUrl}/${program_id}/dashboard/${customer_id}/cancel`,
    payload
  );
};

export const resendDeclarationLink = async ({ program_id, self_declaration_id }) => { 
  return await apiClient.post(
    `${customerUrl}/${program_id}/self-declaration/${self_declaration_id}/resend-link`,
  );
};

export const optOutPatientAction = async ({ program_id, payload }) => {
  return await apiClient.post(
    `${messageUrl}/${program_id}/sms-inbound-messages`,
    payload
  );
}

export const AssignPatientLoadingDose = async ({ program_id, customer_id, payload }) => { 
  return await apiClient.post(
    `${customerUrl}/${program_id}/dashboard/${customer_id}/assign-loading-dose-action`,
    payload
  );
};

export const uploadImage = async ({ program_id, payload }) => {
  try {
    const fileData = new FormData();
    fileData.append('file', payload.file);
    const response =  await apiClient.post(
      `${storageUrl}/${program_id}/anonymous-upload`,
      fileData
    );

    return response;
  } catch (e) {
    return "No content"
  }
}

export const getCustomerFields = async ({ program_id }) => {
  return await apiClient.get(
    `${customerUrl}/${program_id}/private/config`
  );
}

const toQueryString = (queryObject: any) => {
  return queryObject ? `?${Object.keys(queryObject).map(key => key + '=' + queryObject[key]).join('&')}` : '';
}